import moment from 'moment';
import React from 'react';
import { TableInput, TextAreaInput } from '../../../../../components/common';
import DatePickerMui from '../../../../../components/common/DatePickerMui';
import formatDate from '../../../../../components/common/formatDate';
import { useQuery } from '../../../../../hooks/UseQuery';
import SimpleSelect from '../../../../../components/common/SimpleSelect';

export const TableRowComponent = React.memo(
  ({ key, item, index, allmonth, updateModuleData }: any) => {
    const isView = useQuery('isView') === 'true' ? true : false;
    const rowId = item?._id || item?._tempId;

    const handleInputChange = (
      fieldName: string,
      value: string | number | null,
    ) => {
      updateModuleData('row', index, fieldName, { [fieldName]: value });
    };

    return (
      <React.Fragment key={key}>
        <tr>
          <td>{index + 1}</td>
          <td>
            <TextAreaInput
              isView={isView}
              style={{ height: '80px', minWidth: '180px' }}
              name="checkpoint"
              // type="text"
              value={item.checkpoint}
              onChange={(e: any) =>
                handleInputChange(e.target.name, e.target.value)
              }
            />
          </td>
          <td>
            <TableInput
              isView={isView}
              style={{ height: '80px' }}
              name="method"
              type="text"
              value={item.method}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleInputChange(e.target.name, e.target.value)
              }
            />
          </td>
          <td>
            <TableInput
              isView={isView}
              style={{ height: '80px' }}
              name="judgement_criteria"
              type="text"
              value={item.judgement_criteria}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleInputChange(e.target.name, e.target.value)
              }
            />
          </td>
          <td>
            <SimpleSelect
              name={`before`}
              value={item.before}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleInputChange(e.target.name, e.target.value);
              }}
              options={[
                { value: '', label: 'none' },
                { value: 'true', label: '✓' },
                { value: 'false', label: '⨯' },
                { value: 'other', label: 'other' },
              ]}
              style={{
                padding: '8px',
                fontSize: '1.2rem',
                border: '3px solid white',
                borderRadius: '50%',
                cursor: 'pointer',
                outline: 'none',
                width: '70px',
                backgroundColor: 'white',
                color: 'black',
              }}
              optionStyle={{
                backgroundColor: 'white',
                color: 'black',
                width: '40px',
              }}
            />
          </td>
          <td>
            <TableInput
              isView={isView}
              style={{ height: '80px' }}
              name="done_by"
              type="text"
              value={item.done_by}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleInputChange(e.target.name, e.target.value)
              }
            />
          </td>
          <td>
            <TableInput
              isView={isView}
              style={{ height: '80px' }}
              name="history_card"
              type="text"
              value={item.history_card}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleInputChange(e.target.name, e.target.value)
              }
            />
          </td>
          <td style={{ minWidth: '150px', width: '150px' }}>
            <TextAreaInput
              isView={isView}
              style={{ height: '80px' }}
              name="remark"
              //   type="text"
              value={item.remark}
              onChange={(e: any) =>
                handleInputChange(e.target.name, e.target.value)
              }
            />
          </td>
        </tr>
      </React.Fragment>
    );
  },
  (prevProps, nextProps) => {
    // Check if the relevant data for this row has changed
    return (
      prevProps.item === nextProps.item && prevProps.index === nextProps.index
    );
  },
);
